<div class="step-heading">
  <div class="step-title">
    <button matIconButton type="button" aria-label="Indietro" (click)="flow.back()">
      <i class="fa-regular fa-arrow-left" aria-hidden="true"></i>
    </button>
    <span class="title-medium-emphasized">Destino di consegna</span>
  </div>
  <button matButton="outlined" type="button" (click)="flow.go('deliveryForm')">Nuovo destino</button>
</div>

<div class="delivery-search">
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <input matInput placeholder="Cerca indirizzo, località, provincia..." aria-label="Cerca indirizzo, località, provincia" [formControl]="searchControl">
    <i matSuffix class="fa-regular fa-magnifying-glass" aria-hidden="true"></i>
  </mat-form-field>
</div>

@if (addresses().length === 0) {
  <div class="step-empty body-large">Nessun indirizzo trovato</div>
}

<div class="card-list">
  @for (address of addresses(); track address.branchId) {
    <div class="selectable-card" [class.selectable-card--selected]="isSelected(address)" (click)="select(address)">
      <div class="card-heading">
        <mat-radio-button
          class="address-radio"
          [checked]="isSelected(address)"
          [attr.aria-label]="'Seleziona ' + address.indirizzo"
          (change)="select(address)"
        >
          @if (address.tipoSede) {
            <span class="chip chip--info body-medium-emphasized">{{ address.tipoSede }}</span>
          }
        </mat-radio-button>
        @if (address.latitudine != null && address.longitudine != null) {
          <button matIconButton type="button" aria-label="Apri la mappa" (click)="openMap($event, address)">
            <i class="fa-regular fa-location-dot" aria-hidden="true"></i>
          </button>
        }
      </div>

      <div class="address-card-body">
        <span class="body-large-emphasized">{{ address.indirizzo || '—' }}</span>
        <span class="body-large">{{ location(address) }}</span>
      </div>

      @if (isSelected(address)) {
        <div class="delivery-note-form" (click)="$event.stopPropagation()">
          <span class="title-medium-emphasized">Note riportate in bolla</span>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Riferimento</mat-label>
            <input matInput maxlength="35" [value]="delivery(address).riferimento ?? ''" (input)="setRiferimento(address, $any($event.target).value)">
          </mat-form-field>
          <ord-new-customer-delivery-notes [nota]="delivery(address).nota" (notaChange)="setNota(address, $event)" />
        </div>
      }
    </div>
  }
</div>

<div class="delivery-actions">
  <button matFab extended class="continue-floating-button" type="button" (click)="continue()">Prosegui</button>
</div>
